import advisorImage from '@/assets/images/advisor.png'
import BranchesImage from '@/assets/images/contact-us/contact-hero.png'

export const USEFUL_INFORMATION_TABS = [
  {
    id: 'financial-mediator',
    title: 'tabs.financialMediator.title',
    image: advisorImage,
    content: {
      title: 'tabs.financialMediator.content.title',
      body: 'tabs.financialMediator.content.body',
      address: 'tabs.financialMediator.content.address',
      place: 'tabs.financialMediator.content.place',
      phone: 'tabs.financialMediator.content.phone',
      fax: 'tabs.financialMediator.content.fax',
      website: 'tabs.financialMediator.content.website',
      workingHours: 'tabs.financialMediator.content.workingHours',
      days: 'tabs.financialMediator.content.days',
      break: 'tabs.financialMediator.content.break'
    }
  },
  {
    id: 'announcements',
    title: 'tabs.announcements.title',
    content: {
      announcements: [
        {
          title: 'tabs.announcements.content.1.title',
          image: BranchesImage,
          body: {
            p1: 'tabs.announcements.content.1.body.p1',
            p2: 'tabs.announcements.content.1.body.p2',
            linkText: 'tabs.announcements.content.1.body.linkText',
            link: '/branches'
          },
          date: 'tabs.announcements.content.1.date'
        }
      ]
    }
  },
  {
    id: 'links',
    title: 'tabs.usefulLinks.title',
    content: {
      links: [
        {
          id: '1',
          title: 'tabs.usefulLinks.content.centralBank',
          url: 'https://www.cba.am'
        },
        {
          id: '2',
          title: 'tabs.usefulLinks.content.financeForAll',
          url: 'https://www.abcfinance.am'
        },
        {
          id: '3',
          title: 'tabs.usefulLinks.content.yourFinancialInfo',
          url: 'https://www.fininfo.am'
        },
        {
          id: '4',
          title: 'tabs.usefulLinks.content.financialMediator',
          url: 'https://fsm.am/'
        }
      ]
    }
  }
]
